import { render, staticRenderFns } from "./RadioButtonBigSquare.vue?vue&type=template&id=237af3c8&scoped=true&"
import script from "./RadioButtonBigSquare.vue?vue&type=script&lang=js&"
export * from "./RadioButtonBigSquare.vue?vue&type=script&lang=js&"
import style0 from "./RadioButtonBigSquare.vue?vue&type=style&index=0&id=237af3c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237af3c8",
  null
  
)

export default component.exports